import { BUSINESS_TYPE, BusinessType } from "./businessType";

export const parseBusinessType = (value?: string | null): BusinessType | null => {
    if (!value) return null;

    switch (value.trim().toUpperCase()) {
        case "SERVICE_BUSINESS":
            return BUSINESS_TYPE.SERVICE;
        case "FOOD_BUSINESS":
            return BUSINESS_TYPE.FOOD;
        case "OTHER_BUSINESS":
            return BUSINESS_TYPE.OTHER;
        default:
            return null;
    }
};
